import ANALYTIC_EVENTS from "@/feature-analytics/analytic-events.mjs";
import { refs__PRIVATE as refs } from "@/feature-analytics/tracker.mjs";

export function onEnterDestinyGame(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.DESTINY_START, payload);
}

export function onExitDestinyGame() {
  return refs.trackEvent(ANALYTIC_EVENTS.DESTINY_END);
}

export function onDestinyHeartbeat(payload) {
  return refs.trackEvent(ANALYTIC_EVENTS.DESTINY_HEARTBEAT, payload);
}
